import { Component, OnInit } from "@angular/core";
import { AppService } from "../services/app.service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { checkDate as checkDateUtil } from "../utils/format-util";

@Component({
  selector: "app-utilization",
  templateUrl: "./utilization.component.html",
})
export class UtilizationComponent implements OnInit {
  constructor(
    private appservice: AppService,
    private ngxService: NgxUiLoaderService
  ) {}
  successMessage: any = "";
  errorMessage: any = "";
  technologistList: any = [];
  equipmentList: any = [];
  equipmentLists: any = [];
  noRecord = false;
  today = new Date();

  ngOnInit() {
    this.tabSelect("tab1");
  }

  tabSelect(tab) {
    this.noRecord = false;
    if (tab === "tab1") {
      if (this.equipmentList.length === 0) {
        this.ngxService.start();
        this.machineUtilization();
      }
    } else if (tab === "tab2") {
      if (this.technologistList.length === 0) {
        this.ngxService.start();
        this.technologistUtilization();
      }
    }
  }

  private getCurrentDateStr() {
    const date = this.checkDate(this.today.getDate());
    const month = this.checkDate(this.today.getMonth() + 1);
    const year = this.today.getFullYear();

    return year + "-" + month + "-" + date;
  }

  technologistUtilization() {
    const currentDateStr = this.getCurrentDateStr();

    const data = {
      date: currentDateStr,
      strDate: currentDateStr,
      type: "technician",
      tcId: localStorage.getItem("testCenterId"),
      view: "",
    };

    this.appservice.getUtilizationByType(data).subscribe(
      (res) => {
        this.ngxService.stopAll();
        if (res["entity"] != null && res["entity"].length > 0) {
          this.noRecord = false;
          this.technologistList = res["entity"];
        } else {
          this.technologistList = [];
          this.noRecord = true;
        }
      },
      (err) => {
        this.noRecord = true;
        this.technologistList = [];
      }
    );
  }

  machineUtilization() {
    const currentDateStr = this.getCurrentDateStr();

    const data = {
      date: currentDateStr,
      strDate: currentDateStr,
      type: "equipment",
      tcId: localStorage.getItem("testCenterId"),
      view: "",
    };

    this.appservice.getUtilizationByType(data).subscribe(
      (res) => {
        this.ngxService.stopAll();
        if (res["entity"] != null && res["entity"].length > 0) {
          this.noRecord = false;
          for (let index = 0; index < res["entity"].length; index++) {
            const groupBy = res["entity"][index].examShortname;
            this.equipmentLists[index] = res["entity"][index];
            this.equipmentLists[index].groupBy = groupBy
              .toString()
              .substring(0, 10);
          }
          this.equipmentList = this.groupBy(this.equipmentLists, "groupBy");

          for (let index = 0; index < this.equipmentList.length; index++) {
            let totalToday = 0;
            let totalThisWeek = 0;
            let totalThisMonth = 0;
            let totalLastWeek = 0;
            let totalYear = 0;

            for (let j = 0; j < this.equipmentList[index].value.length; j++) {
              totalToday =
                +this.equipmentList[index].value[j].todayUtilization +
                +totalToday;
              totalThisWeek += +this.equipmentList[index].value[j].thisWeek;
              totalThisMonth += +this.equipmentList[index].value[j].thisMonth;
              totalLastWeek += +this.equipmentList[index].value[j].lastWeek;
              totalYear += +this.equipmentList[index].value[j].yearUtilization;

              if (this.equipmentList[index].value.length === j + 1) {
                this.equipmentList[index].value[j].totalToday = totalToday;
                this.equipmentList[index].value[
                  j
                ].totalThisWeek = totalThisWeek;
                this.equipmentList[index].value[
                  j
                ].totalThisMonth = totalThisMonth;
                this.equipmentList[index].value[
                  j
                ].totalLastWeek = totalLastWeek;
                this.equipmentList[index].value[j].totalYear = totalYear;
              }
            }
          }
        } else {
          this.equipmentList = [];
          this.noRecord = true;
        }
      },
      (err) => {
        this.noRecord = true;
        this.equipmentList = [];
      }
    );
  }

  getRound(value): number {
    if (value) {
      return Math.round(value * 100) / 100;
    }
    return 0;
  }

  groupBy(collection: any, property: string): any {
    if (!collection) {
      return null;
    }
    const groupedCollection = collection.reduce((previous, current) => {
      if (!previous[current[property]]) {
        previous[current[property]] = [current];
      } else {
        previous[current[property]].push(current);
      }
      return previous;
    }, {});
    return Object.keys(groupedCollection).map((key) => ({
      key,
      value: groupedCollection[key],
    }));
  }

  checkDate(str) {
    return checkDateUtil(str);
  }
}
